import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box,
  Radio
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dateFormatter, dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN } from '../../../../../constants/dropdown';
import { MedicineDetailForm } from './MedicineDetailForm';
import { LabDetailForm } from './LabDetailForm';
import { ServiceDetailForm } from './ServiceDetailForm';
import { socket } from '../../../../../utils/socket';
const initialPatientDataObj = {
  data: [],
  loading: false
};
const initialPosDataObj = {
  data: [],
  loading: false
};

export const IndentRequisitionForm = () => {
  const doctorIDRef = useRef();
  const sponsorID = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [retailSalePosObj, setRetailSalePosObj] = useState(initialPosDataObj);
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [opdDialogueOpen, setOpdDialogueOpen] = useState(false);
  const [ipdDialogueOpen, setIpdDialogueOpen] = useState(false);
  const [opdPatientDetail, setOpdPatientDetail] = useState([]);
  const [ipdPatientDetail, setIpdPatientDetail] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [qty, setQty] = useState('');
  const [opdData, setOpdData] = useState([]);
  const [ipdData, setIpdData] = useState([]);
  const [posInput, setPosInput] = useState('');
  const [opdInput, setOpdInput] = useState('');
  const [ipdInput, setIpdInput] = useState('');
  const [selectedRadio, setSelectedRadio] = useState('');
  const [posData, setPosData] = useState([]);
  const [opdFilterData, setOpdFilterData] = useState({ data: [] });
  const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
  const productRef = useRef();
  const [productStock, setProductStock] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [wardDropdown, setWardDropdown] = useState([]);
  const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
  const [warehouse, setWareHouse] = useState([]);
  const [medicineDetailDialogue, setMedicineDetailDialogue] = useState(false);
  const [medicinesDetails, setMedicineDetails] = useState([]);
  const [medicineReturnDetails, setMedicineReturnDetails] = useState([]);
  const [labDetailDialogue, setLabDetailDialogue] = useState(false);
  const [labDetails, setLabDetails] = useState([]);
  const [serviceDialogue, setServiceDialogue] = useState(false);
  const [serviceDetails, setServiceDetails] = useState([]);
  const [indentData, setIndentData] = useState([]);
  const [selectedIndentRadio, setSelectedIndentRadio] = useState('ipd_indent');
  const [originalOpdData, setOriginalOpdData] = useState([]);
  const [medicine, setMedicine] = useState([]);
  const [test, setTest] = useState([]);
  const [service, setService] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));

  const { getValues } = useForm();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // location_to: Yup.string().required(' '),
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const IPD_TABLE_HEADER = [
    { header: 'Patient Name', accessor: (row) => row?.patient?.name },
    { header: 'Ipd No.', accessor: 'ipd_no' },
    { header: 'Uhid', accessor: 'uhid' },
    {
      header: 'Ward Name',
      accessor: (row) => row?.consultant_detail?.room?.ward?.name
    }
  ];

  const OPD_TABLE_HEADER = [
    { header: 'Patient Name', accessor: (row) => `${row?.name_suffix}${row?.first_name}${row?.last_name}` },
    { header: 'Uhid', accessor: 'uhid' },
    {
      header: 'Ward Name',
      accessor: (row) => row?.consultant_detail?.room?.ward?.name
    }
  ];

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }

    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  }, []);

  const getRoomMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomMasterDropdown(data);
  }, []);

  const getWareHouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    setWareHouse(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('sponsor', defaultSponsor?._id);
    }
    setSponsorDropdown(data);
  }, []);

  useEffect(() => {
    getDoctorDropdown();
    getSponsorDropdown();
    getWardDropdown();
    getRoomMasterDropdown();
    getWareHouseDropdown();
  }, [getDoctorDropdown, getSponsorDropdown, getWardDropdown, getRoomMasterDropdown, getWareHouseDropdown]);

  useEffect(() => {
    let total_amount = 0;
    let bill_amount = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;
    let gst = 0;
    const gstValue = tableData.length > 0 ? tableData[tableData.length - 1].gst : 0;
    tableData.forEach((detail) => {
      const amount = detail.rate * detail.bill_qty;
      bill_amount += amount;
      total_amount += amount;
      total_amt += amount;
    });
    const roundedNetAmt = Math.round(net_amt);
    const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));
    setValue(
      'total_qty',
      tableData.reduce((acc, curr) => acc + curr.bill_qty, 0)
    );
    setValue('total_amt', total_amt);
    setValue('gst', gstValue);
    setValue('bill_amount', bill_amount);
    setValue('disc_amt', disc_amt);
    setValue('gst_amt', gst_amt);
    setValue('net_amt', roundedNetAmt);
    setValue('round_off', Math.abs(roundOff));
  }, [detailList, setValue, tableData]);
  const TotalAmount = watch('total_amt');
  const DisPercent = watch('dis_per');
  const DisAmt = watch('dis_amount');
  const recAmt1Watch = watch('recpt_1');
  const recAmt2Watch = watch('recpt_2');
  const taxable = watch('bill_amount');
  const gstPer = watch('gst');
  const cgst = watch('cgst');
  const sgst = watch('sgst');
  useEffect(() => {
    const calculatedDisAmt = (TotalAmount * (DisPercent / 100) || 0).toFixed(2);
    const calculateBillamt = (TotalAmount - calculatedDisAmt).toFixed(2);
    const calculatesgst = (taxable * (gstPer / 100) || 0).toFixed(2);
    console.log('calculated SGST:', calculatesgst);
    setValue('dis_amount', parseFloat(calculatedDisAmt));
    setValue('bill_amount', parseFloat(calculateBillamt) || 0);
    const total_recpt = (parseFloat(recAmt1Watch) || 0) + (parseFloat(recAmt2Watch) || 0);
    setValue('total_recpt', total_recpt.toFixed(2));
    const amountAfterDiscount = TotalAmount - parseFloat(calculatedDisAmt);
    const balanceAmt = amountAfterDiscount - total_recpt;
    setValue('balance', balanceAmt.toFixed(2));
    setValue('cgst', (parseFloat(calculatesgst) / 2).toFixed(2));
    setValue('sgst', (parseFloat(calculatesgst) / 2).toFixed(2));
  }, [TotalAmount, DisPercent, recAmt1Watch, recAmt2Watch, setValue]);

  const handleRadioChange = (event) => {
    const { name } = event.target;
    setSelectedRadio(name);
    const defaultLocation = warehouse.find((item) => item.status === 'default');
    const locationId = defaultLocation?._id;
    if (name === 'MR' || 'M') {
      setValue('location_to', locationId);
    } else {
      setValue('location_to', '');
    }
  };

  const handleRadioIndentChange = (event) => {
    const { name } = event.target;
    setSelectedIndentRadio(name);
  };

  const getMedicineDropdown = useCallback(async () => {
    try {
      const data = await dropdownFetch('stock-master');
      const uniqueProductMap = new Map();
      const filteredProducts = data.flatMap((item) =>
        item.productDetails.filter((detail) => {
          const productId = detail.product._id;
          if (!uniqueProductMap.has(productId)) {
            uniqueProductMap.set(productId, true);
            return true;
          }
          return false;
        })
      );

      setMedicine(filteredProducts);
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  }, []);

  const getTestDropdown = useCallback(async () => {
    const data = await dropdownFetch('lis-test');
    setTest(data);
  }, []);

  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service');
    setService(data);
  }, []);

  useEffect(() => {
    getMedicineDropdown();
    getTestDropdown();
    getServiceDropdown();
  }, [getMedicineDropdown, getTestDropdown, getServiceDropdown]);

  const formSubmit = async (formValues) => {
    if (
      !(
        labDetails.length > 0 ||
        serviceDetails.length > 0 ||
        medicinesDetails.length > 0 ||
        medicineReturnDetails.length > 0 ||
        watch('ipd_no') !== ''
      )
    ) {
      toast('Please add the Details first', { variant: 'warning' });
      return;
    }

    setLoading(true);
    const items = labDetails?.length
      ? labDetails
      : serviceDetails?.length
        ? serviceDetails
        : medicinesDetails?.length
          ? medicinesDetails
          : medicineReturnDetails;
    const indent_type = selectedRadio;
    const patient_type = selectedIndentRadio;
    const payload = {
      ...formValues,
      indent_type,
      patient_type,
      items
    };
    const editFlag = selectedRecord && currentAction === 'edit';
    try {
      const response = await request(editFlag ? `/indent-update/${selectedRecord._id}` : '/indent-create', {
        method: editFlag ? 'PUT' : 'POST',
        body: {
          ...payload,
          createdBy: user.name,
          updatedBy: editFlag ? user.name : '',
          organisation
        }
      });
      if (response?.success && response.data) {
        toast(`Successfully ${editFlag ? 'edited' : 'created'} Indent Requisition`, { variant: 'success' });
        setSelectedRecord(response.data);
        setCurrentAction();
        fetchIndent();
        setLabDetails([]);
        setServiceDetails([]);
        setMedicineDetails([]);
        setDetailList([]);
        setSelectedRadio('');
        reset();
      } else {
        toast(`Failed to ${editFlag ? 'edit' : 'create'} Indent Requisition`, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error submitting the form:', error);
      toast('An error occurred while processing your request', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRetailSalePosObj({ loading: true });
    const response = await request('/retail-sale-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setRetailSalePosObj({ loading: false, data: filteredData });
      setPosData({ loading: false, data: response.data });
    } else {
      toast('Failed to load Retail Sale list', { variant: 'error' });
      setRetailSalePosObj({ loading: false });
    }
  };

  const handleRowDelete = (row) => {
    console.log('HELLLO ID OF ROW', row);
    setMedicineDetails((prev) => prev.filter((data) => data.medicine !== row));
    setLabDetails((prev) => prev.filter((data) => data.test !== row));
    setServiceDetails((prev) => prev.filter((data) => data.service_name !== row));
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (productStock && productStock.length > 0) {
      setOriginalData(productStock);
      setIsFiltered(false);
    }
  }, [productStock]);

  const handleProductSearch = (searchValue) => {
    const lowercasedInput = searchValue.toLowerCase();
    const filtered = indoorRegisterationDataObj.filter((item) =>
      item.productDetails[0].product?.toString().toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };

  const handleChangelk = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handleProductSearch(newInput);
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleRowClick = (row) => {
    console.log('HELLLLO ROW', row);
    setValue('patient_name', row?.patient?.name);
    setValue('uhid', row?.uhid);
    setValue('ipd_no', row?.ipd_no);
    setValue('consultant', row?.consultant_detail?.doctor?._id);
    setValue('gender', row?.patient?.gender);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('room', row?.consultant_detail?.room?._id);
    setValue('ward', row?.consultant_detail?.room?.ward._id);
    setValue('bed_no', row?.consultant_detail?.bed_no);
    setValue('sponsor', row?.patient?.sponsor);
    sponsorID.current = row?.patient?.sponsor;
  };

  const handleRowOpdClick = (row) => {
    console.log('HELLLLO ROW', row);
    setValue('patient_name', `${row?.name_suffix}${row?.first_name}  ${row?.last_name}`);
    setValue('gender', `${row?.gender}`);
    setValue('age', calculateAge(row?.dob));
    setValue('uhid', row?.uhid);
    setValue('consultant', row?.consultant?._id);
    doctorIDRef.current = row?.consultant?._id;
    setValue('sponsor', row?.sponsor?._id);
  };

  const handleQtyChange = (e) => {
    setQty(e.target.value);
  };
  const fetchOpdPatients = async () => {
    setPatientDataObj({ loading: true });
    try {
      const response = await request('/patient-registeration-list', { method: 'GET' });
      if (response.success) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const filteredData = response.patientData.filter((patient) => {
          const createdAtDate = new Date(patient.createdAt);
          return createdAtDate >= today && createdAtDate < new Date(today.getTime() + 86400000);
        });
        const sortedData = filteredData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPatientDataObj({ loading: false, data: sortedData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };

  const fetchIpdPatient = async () => {
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/indoor-registeration-list-admit-patient',{ method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter((item) => item.admission_status === 'admit');
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setIpdData(sortedData);
      setIpdFilterData({ data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };

  const fetchIndent = async () => {
    const response = await request('/indent-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter((item) => item.authorize === false);
      setIndentData({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndentData({ loading: false });
    }
  };

  useEffect(() => {
    fetchIpdPatient();
    fetchOpdPatients();
    fetchIndent();
  }, ['ipd_indent', 'opd_indent']);

  const saleMode = watch('sale_mode');
  const handleOpdPatient = (row) => {
    setOpdPatientDetail(row);
    console.log('HELLO OPD PATEINT DETAILS', opdPatientDetail);
    setOpdDialogueOpen(false);
  };

  const handleIpdRow = (row) => {
    setIpdPatientDetail(row);
    console.log('HELLO IPD PATEINT DETAILS', ipdPatientDetail);
    setIpdDialogueOpen(false);
  };
  const handleAdd = () => {
    if (!selectedRow) return;
    const updatedRow = {
      ...selectedRow,
      bill_qty: qty
    };
    const updatedTableData = tableData.some((row) => row._id === selectedRow._id)
      ? tableData.map((row) => (row._id === selectedRow._id ? updatedRow : row))
      : [...tableData, updatedRow];
    setTableData(updatedTableData);
    setQty('');
    setSelectedRow(null);
    if (productRef.current) {
      productRef.current.focus();
    }
  };

  useEffect(() => {
    if (productRef.current) {
      productRef.current.focus();
    }
  }, []);

  const productData = tableData.map((row) => ({
    ...row,
    amount: row.rate * row.bill_qty
  }));

  const ITEM_DETAIL_HEADER = [
    {
      header: 'Item Name',
      accessor: (row) => row.medicine_name || row.test_name || row.service
    },
    {
      header: 'Quantity',
      accessor: 'quantity'
    }
  ];

  const PATIENT_STATUS_HEADER = [
    {
      header: 'Patient Name',
      accessor: (row) => `${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name}        `
    },
    {
      header: 'Indent No.',
      accessor: (row) => row?.indent_no
    },
    { header: 'Date', accessor: (row) => dateFormatter(row?.createdAt) }
  ];

  useEffect(() => {
    if (retailSalePosObj && retailSalePosObj.length > 0) {
      setPosData(retailSalePosObj);
      setIsFiltered(false);
    }
  }, [retailSalePosObj]);

  const handlePosData = (searchValue) => {
    const posDataArray = posData.data || [];
    const lowercasedInput = searchValue.toLowerCase();
    const filtered = posDataArray.filter((item) => item.inv_no.toString().toLowerCase().includes(lowercasedInput));
    setPosData({ ...posData, data: filtered });
  };
  const handleChangePos = (e) => {
    const newInput = e.target.value;
    setPosInput(newInput);
    handlePosData(newInput);
  };

  useEffect(() => {
    if (opdData && opdData.length > 0) {
      setOpdFilterData({ data: opdData });
      setIsFiltered(false);
    }
  }, [opdData]);

  const handleOpdDataFilter = (searchValue) => {
    const opdDataArray = opdFilterData.data || [];
    const lowercasedInput = searchValue.toLowerCase();

    const filtered = opdDataArray.filter((item) => item.uhid.toString().includes(lowercasedInput));
    setOpdFilterData((prevData) => ({ ...prevData, data: filtered }));
  };

  const handleOpdChange = (e) => {
    const newInput = e.target.value;
    setOpdInput(newInput);
    handleOpdDataFilter(newInput);
  };

  useEffect(() => {
    if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data)) {
      setIpdFilterData({ data: indoorRegisterationDataObj.data });
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj]);

  const handleIpdDataFilter = (searchValue) => {
    const ipdDataArray = ipdFilterData?.data || [];
    const lowercasedInput = searchValue.toLowerCase();
    const filtered = ipdDataArray.filter(
      (item) => item.uhid.toString().includes(lowercasedInput) || item.ipd_no.toString().includes(lowercasedInput)
    );
    setIpdFilterData((prevData) => ({ ...prevData, data: filtered }));
  };


  const handleIpdChange = (e) => {
    const newInput = e.target.value;
    setIpdInput(newInput);
    handleIpdDataFilter(newInput);
  };

  const handleAuthorize = async (row) => {
    setLoading(true);
    try {
      const response = await request('/indent-authorize', {
        method: 'PUT',
        params: row._id
      });
      if (response?.success) {
        toast('Successfully authorized Indent', { variant: 'success' });

        socket.emit('sendNotification', {
          rooms: ['inventory'], // Replace with dynamic room names if applicable
          message: `A new indent requisition was ${'created'}.`,
          sender: user?.username || 'System' // Add the sender's name
        });
        setSelectedRecord(response.data);
        setCurrentAction();
        fetchIndent();
      }
      console.log('HELLLO ROW ID', row.indent_no);
    } catch (error) {
      toast('An error occurred while authorizing Indent', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      indoorRegisterationDataObj &&
      Array.isArray(indoorRegisterationDataObj.data) &&
      indoorRegisterationDataObj.data.length > 0
    ) {
      setOriginalData(indoorRegisterationDataObj.data);
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj.data]);

  useEffect(() => {
    if (patientDataObj && Array.isArray(patientDataObj.data) && patientDataObj.data.length > 0) {
      setOriginalOpdData(patientDataObj.data);
      setIsFiltered(false);
    }
  }, [patientDataObj.data]);

  useEffect(() => {
    handlePatientSearch(input);
  }, [input]);

  const handlePatientSearch= async () => {
    const lowercasedInput = input.toLowerCase().trim();
    const query = {};
    if (lowercasedInput) {
      query.name = lowercasedInput;
    }
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/indoor-registeration-list-admit-patient', { method: 'GET',query: query});
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter((item) => item.admission_status === 'admit');
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setIpdData(sortedData);
      setIpdFilterData({ data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };

  const handleOpdPatientSearch = (searchInput) => {
    if (Array.isArray(patientDataObj.data)) {
      const lowercasedInput = searchInput.toLowerCase();
      const filtered = patientDataObj.data.filter((item) => {
        const uhidMatch = item.uhid && item.uhid.toString().toLowerCase().includes(lowercasedInput);
        const firstNameMatch =
          item.first_name && item.first_name && item.first_name.toLowerCase().includes(lowercasedInput);

        return uhidMatch || firstNameMatch;
      });

      setOriginalOpdData(filtered);
      setIsFiltered(true);
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  useEffect(() => {
    console.log('helllo medicine data', medicine);
  });

  const onAddDetailHandler = (row) => {
    // Check if the medicine is already in the details
    const existingDetail = medicinesDetails.find(({ medicine }) => medicine === row.medicine);
    if (existingDetail) {
      toast('Medicine already chosen', { variant: 'error' });
      return;
    } else {
      toast('Product Added Successfully ', { variant: 'success' });
    }

    // Find the medicine data based on the given medicine's product ID (row.medicine)
    const medicineData = medicine.find(({ product }) => product?._id === row.medicine);

    console.log('HELLLLO MEDICINE DATATATATTATA', medicineData);
    // Extract the product name from the medicineData, ensuring that productDetails exists
    const productName = medicineData?.product?.main?.name;
    const medicineId = medicineData?.product?._id;

    // If product name is not found, show an error
    if (!productName) {
      toast('Product name not found', { variant: 'error' });
      return;
    }

    // Add the new medicine detail to the state
    setMedicineDetails((prev) => [
      ...prev,
      {
        medicine_name: productName, // The name of the medicine
        medicine: medicineId, // The ID of the medicine
        conversion: row.conversion, // The conversion rate
        quantity: row.quantity,
        stock: row.stock,
        rate: row.rate,
        exp_date: row.exp_date,
        batch_no: row.batch_no
      }
    ]);
  };

  const onAddLabDetailHandler = (row) => {
    const existingDetail = labDetails.find(({ test }) => test === row.test);
    if (existingDetail) {
      toast('Test already chosen', { variant: 'error' });
      return;
    }
    const testData = test.find(({ _id }) => _id === row.test);
    if (!testData) {
      toast('Test not found', { variant: 'error' });
      return;
    }
    const productName = testData.test_name;
    const testId = testData._id;
    if (!productName) {
      toast('Test name not found', { variant: 'error' });
      return;
    } else {
      toast('Test Added Successfully', { variant: 'success' });
    }
    setLabDetails((prev) => [
      ...prev,
      {
        test_name: productName,
        test: testId,
        quantity: row.quantity
      }
    ]);
  };

  const onAddServiceDetailHandler = (row) => {
    const existingDetail = serviceDetails.find(({ service_name }) => service_name === row.service_name);
    if (existingDetail) {
      toast('Service already chosen', { variant: 'error' });
      return;
    }
    const serviceData = service.find(({ _id }) => _id === row.service_name);
    if (!serviceData) {
      toast('Service not found', { variant: 'error' });
      return;
    }
    const productName = serviceData.service_name;
    const serviceId = serviceData._id;
    if (!productName) {
      toast('Service Name not found', { variant: 'error' });
      return;
    } else {
      toast('Service Added Successfully', { variant: 'success' });
    }
    setServiceDetails((prev) => [
      ...prev,
      {
        service_name: serviceId,
        service: productName,
        quantity: row.quantity
      }
    ]);
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={1}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Indent Orders & Requisition
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    setMedicineDetails([]);
                    setServiceDetails([]);
                    setLabDetails([]);
                    setMedicineReturnDetails([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn id={`isSuperAdmin`} variant="contained" disabled onClick={handleDeleteRecord}>
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box sx={{ padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
              <Grid container spacing={1}>
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.2} direction="row" alignItems="center">
                    <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        flex: 0.3
                      }}
                      name="ipd_indent"
                      checked={selectedIndentRadio === 'ipd_indent'}
                      onChange={handleRadioIndentChange}
                    />
                    <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Ipd Indent</Typography>
                    {/* <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        flex: 0.2
                      }}
                      name="opd_indent"
                      checked={selectedIndentRadio === 'opd_indent'}
                      onChange={handleRadioIndentChange}
                    />
                    <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Opd Indent</Typography> */}
                  </Stack>
                  <Grid
                    item
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: '40rem',
                      marginTop: '1%',
                      boxShadow: '0px 2px 4px #0099ff'
                    }}
                  >
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px',
                            fontSize: '1.5rem' // Increase input font size here
                          },
                          '& .MuiInputLabel-root': {
                            fontSize: '1.5rem' // Increase label font size here
                          }
                        }}
                        label="Search Admitted Patient"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                        inputRef={productRef}
                      />
                    </Stack>

                    {selectedIndentRadio === 'ipd_indent' ? (
                      <Table
                        containerSX={{
                          flex: 1,
                          border: '0px solid rgba(0,0,0,0.27)',
                          minHeight: '48rem',
                          borderRadius: 1
                        }}
                        data={currentAction === 'new' ? originalData : []}
                        columns={IPD_TABLE_HEADER}
                        size="small"
                        onRowClick={(row) => {
                          handleRowClick(row);
                        }}
                      />
                    ) : (
                      <Table
                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '48rem' }}
                        data={currentAction === 'new' ? originalOpdData : []}
                        columns={OPD_TABLE_HEADER}
                        size="small"
                        onRowClick={(row) => {
                          handleRowOpdClick(row);
                        }}
                      />
                    )}
                  </Grid>
                </Grid>

                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack
                    sx={{
                      border: '0px solid grey',
                      padding: '5px',
                      borderRadius: '5px',
                      boxShadow: '0px 2px 6px #0099ff'
                    }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={1} direction="row" alignItems="center">
                        <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', flex: 2 }}>Indent Type</Typography>
                        <Radio
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            labDetails.length > 0 ||
                            serviceDetails.length > 0 ||
                            medicineReturnDetails.length > 0
                          }
                          sx={{ flex: 0 }}
                          name="M"
                          checked={selectedRadio === 'M'}
                          onChange={handleRadioChange}
                        />
                        <Typography
                          sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}
                        >
                          M
                        </Typography>
                        <Radio
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            medicinesDetails.length > 0 ||
                            serviceDetails.length > 0 ||
                            labDetails.length > 0
                          }
                          sx={{ flex: 0 }}
                          name="MR"
                          checked={selectedRadio === 'MR'}
                          onChange={handleRadioChange}
                        />
                        <Typography
                          sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}
                        >
                          MR
                        </Typography>
                        <Radio
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            medicinesDetails.length > 0 ||
                            serviceDetails.length > 0 ||
                            medicineReturnDetails.length > 0
                          }
                          sx={{ flex: 0 }}
                          name="L"
                          checked={selectedRadio === 'L'}
                          onChange={handleRadioChange}
                        />
                        <Typography
                          sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}
                        >
                          L
                        </Typography>
                        <Radio
                          disabled={
                            !['new', 'edit'].includes(currentAction) ||
                            labDetails.length > 0 ||
                            medicinesDetails.length > 0 ||
                            medicineReturnDetails.length > 0
                          }
                          sx={{ flex: 0 }}
                          name="S"
                          checked={selectedRadio === 'S'}
                          onChange={handleRadioChange}
                        />
                        <Typography
                          sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}
                        >
                          S
                        </Typography>
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                          Sponsor
                        </Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="sponsor"
                          placeholder="Select Sponsor"
                          menus={sponsorDropdown}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                          Remarks
                        </Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="remarks"
                          placeholder="Remarks"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                          Indent No.
                        </Typography>
                        <TextField
                          disabled
                          sx={{ flex: 0.8, backgroundColor: currentAction ? '#B3E5FC' : '' }}
                          name="referral_name"
                          placeholder="Indent No."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                          Location To
                        </Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="location_to"
                          placeholder="Location To"
                          menus={warehouse.map((data) => ({
                            ...data,
                            name: data.warehouse_name
                          }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                          Gender/Age
                        </Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.4 }}
                          name="gender"
                          placeholder="Select Gender"
                          menus={GENDER_DROPDOWN}
                        />
                        <TextField disabled sx={{ flex: 0.4 }} name="age" placeholder="Age" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                          Ward
                        </Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="ward"
                          placeholder="Select Ward"
                          onChange={() => {
                            setValue('room', '');
                            setValue('bed_no', '');
                          }}
                          menus={wardDropdown}
                        />
                      </Stack>

                      {/* <Stack spacing={0.2} direction="row" alignItems="center">
                      <Button sx={{ fontWeight: 700, fontSize: '0.7rem', }} variant="contained">Show Alternate Medicine</Button>
                    </Stack> */}
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Date/Time</Typography>
                        <TextField
                          disabled
                          sx={{ flex: 0.4, backgroundColor: currentAction ? '#B3E5FC' : '' }}
                          name="date"
                          type="date"
                        />
                        <TextField
                          disabled
                          sx={{ flex: 0.4, backgroundColor: currentAction ? '#B3E5FC' : '' }}
                          name="time"
                          type="time"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Ipd/Uhid No.</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="ipd_no" placeholder="Ipd No." />
                        <TextField disabled sx={{ flex: 0.4 }} name="uhid" placeholder="Uhid" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Consultant</Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="consultant"
                          placeholder="Select Consultant"
                          menus={doctorDropdown}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Room/Bed</Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.4 }}
                          name="room"
                          menus={roomMasterDropdown
                            .filter((data) => data.ward === watch('ward'))
                            .map((data) => ({ ...data, name: data.room_no }))}
                          onChange={() => {
                            setValue('bed_no', '');
                          }}
                          placeholder="Select Room"
                        />
                        <TextField disabled sx={{ flex: 0.4 }} name="bed_no" placeholder="Bed No." />
                      </Stack>
                    </Grid>
                  </Stack>
                  <Typography
                    onClick={() => {
                      if (selectedRadio === 'M') {
                        setMedicineDetailDialogue(true);
                        setLabDetailDialogue(false);
                        setServiceDialogue(false);
                      } else if (selectedRadio === 'MR') {
                        setMedicineDetailDialogue(true);
                        setLabDetailDialogue(false);
                        setServiceDialogue(false);
                      } else if (selectedRadio === 'L') {
                        setLabDetailDialogue(true);
                        setMedicineDetailDialogue(false);
                        setServiceDialogue(false);
                      } else if (selectedRadio === 'S') {
                        setServiceDialogue(true);
                        setMedicineDetailDialogue(false);
                        setLabDetailDialogue(false);
                      }
                    }}
                    sx={{ fontWeight: 700, fontSize: '1.4rem', color: 'blue', cursor: 'pointer' }}
                  >
                    Add Details
                  </Typography>
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3 }}>
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, boxShadow: '0px 2px 4px #0099ff' }}
                    >
                      <Table
                        containerSX={{
                          flex: 1,
                          border: '0px solid rgba(0,0,0,0.27)',
                          height: '500px', // Set the height for the table
                          overflow: 'auto' // Enable scrolling when content exceeds the height
                        }}
                        data={[
                          ...medicinesDetails.map((data) => ({ _id: data.medicine, ...data })),
                          ...labDetails.map((data) => ({ _id: data.test, ...data })),
                          ...serviceDetails.map((data) => ({ _id: data.service_name, ...data }))
                        ]}
                        columns={ITEM_DETAIL_HEADER}
                        size="small"
                        showDeleteAction={true}
                        onDeleteHandler={handleRowDelete}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, boxShadow: '0px 2px 4px #0099ff' }}
                    >
                      <Table
                        containerSX={{
                          flex: 1,
                          border: '0px solid rgba(0,0,0,0.27)',
                          height: '500px', // Set the height for the table
                          overflow: 'auto' // Enable scrolling when content exceeds the height
                        }}
                        data={indentData.data || []}
                        columns={PATIENT_STATUS_HEADER}
                        size="small"
                        showAuthorize={true}
                        onAuthorizeHandler={handleAuthorize}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={medicineDetailDialogue}
        onClose={() => setMedicineDetailDialogue(false)}
        PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <MedicineDetailForm
          onClose={() => setMedicineDetailDialogue(false)}
          medicine={medicine}
          onAdd={(row) => {
            onAddDetailHandler(row);
            setMedicineReturnDetails((prev) => [...prev, row]);
          }}
        />
      </Dialog>
      <Dialog
        open={labDetailDialogue}
        onClose={() => setLabDetailDialogue(false)}
        PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <LabDetailForm
          onClose={() => setLabDetailDialogue(false)}
          sponsorID={sponsorID.current}
          test={test}
          onAdd={(row) => {
            onAddLabDetailHandler(row);
          }}
        />
      </Dialog>
      <Dialog
        open={serviceDialogue}
        onClose={() => setServiceDialogue(false)}
        PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <ServiceDetailForm
          onClose={() => setServiceDialogue(false)}
          doctorID={doctorIDRef.current}
          sponsorID={sponsorID.current}
          service={service}
          onAdd={(row) => {
            onAddServiceDetailHandler(row);
          }}
        />
      </Dialog>
    </>
  );
};
